export const WORKLOAD_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  TERMINATED: "terminated"
} as const

export const WorkLoadStatuses = [
  WORKLOAD_STATUS.ACTIVE,
  WORKLOAD_STATUS.INACTIVE,
  WORKLOAD_STATUS.TERMINATED
] as const

export const APPLICATION_SOURCE = {
  K8S: "k8s",
  ECS: "ecs",
  VM: "vm",
  VM_CONTAINER: "vmContainer",
  LAMBDA: "lambda",
  AZURE_APP: "azureApp",
  AGENTCORE: "agentcore",
  FOUNDRY_AGENT: "foundryAgent"
} as const

// Applications that run no image of their own (Lambda functions, image-less Azure apps, agents
// deployed as code): the API presents each of them as an image resource that stands in for the
// application
export const STAND_IN_APPLICATION_SOURCES = [
  APPLICATION_SOURCE.LAMBDA,
  APPLICATION_SOURCE.AZURE_APP,
  APPLICATION_SOURCE.AGENTCORE,
  APPLICATION_SOURCE.FOUNDRY_AGENT
] as const

// Applications that are AI agents hosted on an agent platform; the runtime sensor reports the tool
// calls they make
export const AGENT_APPLICATION_SOURCES = [
  APPLICATION_SOURCE.AGENTCORE,
  APPLICATION_SOURCE.FOUNDRY_AGENT
] as const
